import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { Person } from '@/interfaces/person';
import { DetailLicenseById } from '@/interfaces/search/search.interface';
import { SearchService } from '@/services/search/search.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { normalize } from '@/utils/normalizeString';
import { ofuscate } from '@/utils/obfuscation';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import SwiperCore, { A11y, Autoplay, Controller, Navigation, Pagination, Scrollbar, Thumbs, Virtual, Zoom } from 'swiper/core';
import { AuthService } from '@/auth/service/auth.service';
import { Roles } from '@/auth/enum/auth.enum';

SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
]);

@Component({
  selector: 'app-search-driver-licenses-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  @Input() completeLicenseData: CompleteLicense[] = [];
  @Input() zonesRows: Array<number[]> = [];
  @Input() gettingLicenses: boolean = false;
  @Input() gettingLicensesError: string = 'DEFAULT_VALUE';
  @Output() navigate = new EventEmitter();
  @Input() personData!: Person;
  @Output() refreshLicenseCards = new EventEmitter();

  gettingDetailsByLicense: boolean = false;
  gettingLDetailsByLicenseError: string = 'DEFAULT_VALUE';

  showDetailLicense: boolean = false;
  longNameAsseteOfLicense: string = '';
  idLicense: number = 0
  showLinkReactivate: boolean = false;
  userId: string = '';
  shouldShowModal: boolean = false;
  licenseSelected?: CompleteLicense;
  detailLicenseSelected: DetailLicenseById[] = [];
  detailLicenseByIdLicense?: DetailLicenseById;

  selectedLicenseIndex: number = 0;

  get shouldShowModify(): boolean {
    const approverRoles: Roles[] = [
      'DLMS_SOL_OPE_MEL',
      'DLMS_SOL_PRO_MEL',
      'DLMS_SOL_OPE_SPC',
      'DLMS_SOL_PRO_SPC',
    ];

    return approverRoles.some((role) => this.auth.userHaveRole(role));
  }

  constructor(
    private store: Store<StoreState>,
    private router: Router,
    private searchService: SearchService,
    private readonly auth: AuthService,
  ) {
    const storeSlice$ = getCurrentUserData(this.store);
    storeSlice$.subscribe({
      next: (newState) => {
        this.userId = newState.mdmid;
      },
    });
  }

  get shouldShowSuspendOrReactivateButton(): boolean {
    return true;
  }

  get shouldShowDeleteButton(): boolean {
    return true;
  }

  buttonShow: Array<'SUSPEND' | 'REACTIVATE'> = [];

  ngOnInit(): void {
    this.completeLicenseData.map((license, index) => {
      const stateLicense = normalize(license.sanction?.sanctionType);
      let result: 'SUSPEND' | 'REACTIVATE' = 'SUSPEND';
      if (stateLicense === normalize('Suspendida')) {
        result = 'REACTIVATE';
      }
      this.buttonShow[index] = result;
    });
  }

  controlledSwiper: any;
  setControlledSwiper(swiper: any) {
    this.controlledSwiper = swiper;
  }

  getStatesLicenses() {

  }

  openModal(idLicense: number) {
    this.idLicense = idLicense;
    this.licenseSelected = this.completeLicenseData.find(({ id }) => id === idLicense);
    this.shouldShowModal = true;
  }

  closeModal() {
    this.shouldShowModal = false;
  }
  onBack() {
    this.showDetailLicense = false;
  }
  showDetailDelete(idLicenseSelected: number) {
    this.gettingDetailsByLicense = true;
    if (this.completeLicenseData) {
      this.idLicense = idLicenseSelected;

      this.searchService.getDetailLicense(this.idLicense).subscribe({
        next: (res) => {
          this.detailLicenseSelected = res;
          const licenseSelected = this.detailLicenseSelected.find(({ id }) => id === idLicenseSelected);

          if (licenseSelected) {
            this.gettingDetailsByLicense = false;
            this.showDetailLicense = true;
            this.detailLicenseByIdLicense = licenseSelected;
            this.selectedLicenseIndex = this.completeLicenseData.findIndex(({ id }) => id === idLicenseSelected);
          }
        },
        error: () => {
          this.showDetailLicense = false;
          this.gettingDetailsByLicense = false;
          this.gettingLicensesError = 'Hubo un problema al obtener el detalle de la Licencia.';
        },

      });
    }
  }

  onReactivate(idLicenseSelected?: number) {

    const licenseSelected = this.completeLicenseData.find(({ id }) => id === idLicenseSelected);

    if (licenseSelected) {
      this.longNameAsseteOfLicense = licenseSelected.asset.name;
      this.idLicense = licenseSelected.id;
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de reactivar esta licencia?',
        text: 'La licencia quedará vigente automaticamente.',
        text2: 'Si no estás seguro, presiona Volver.',
        acceptButtonText: 'Reactivar Licencia',
        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          const currentOfuscatedData = this.router.url.split('/').reverse()[1];
          this.searchService.onReactivate(this.idLicense)
            .subscribe({
              next: () => {
                this.store.dispatch(loaderAnimationHide());
                const ofuscatedData = ofuscate({
                  title: 'Reactivar Licencia',
                  subtitle: `La licencia ${this.longNameAsseteOfLicense} ha sido reactivada exitosamente.`,
                  messageBold: `N° registro: ${idLicenseSelected}`,
                  message: `Una copia de la reactivación fue enviada al
              correo electrónico ${this.personData.email}`,
                  actionButtonPath: `/search/driver/result/${currentOfuscatedData}/licenses`,
                  actionButtonText: 'Ir al perfil de conductor',
                });
                this.router.navigateByUrl(`/search/action/result/${ofuscatedData}`);
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      const ofuscatedData = ofuscate({
                        variant: 'failure',
                        title: 'Reactivar Licencia',
                        subtitle: 'Hubo un problema y no hemos podido reactivar la licencia. Por favor intenta de nuevo.',
                        actionButtonPath: `/search/driver/result/${currentOfuscatedData}`,
                        actionButtonText: 'Ir al perfil de conductor',
                      });
                      this.router.navigateByUrl(`/search/action/result/${ofuscatedData}`);
                    }
                  },
                });

              },
            });

        },

      }));
    }
  }
}
